import React from 'react';
import PropTypes from 'prop-types';
import { WORKFORCE_LEGEND_BOUNDS, WORKFORCE_COLOR_SCALES } from '../../constants';

export default function LegendBar({ metricType }) {
  const key = metricType === 'employment' ? 'emp_count' : metricType;
  const bounds = WORKFORCE_LEGEND_BOUNDS[key] || [];
  if (!bounds.length) return null;

  const colors = WORKFORCE_COLOR_SCALES[key] || [];

  const bins = [];

  // Helper for formatting numbers
  const fmt = v =>
    metricType === 'wages' ? `$${v.toLocaleString()}` : v.toLocaleString();

  // Build bins for legend
  bins.push({ label: `<${fmt(bounds[0])}`, value: bounds[0] });

  for (let i = 0; i < bounds.length - 1; i += 1) {
    bins.push({ label: `${fmt(bounds[i])}-${fmt(bounds[i + 1])}`, value: bounds[i + 1] });
  }

  bins.push({ label: `>${fmt(bounds[bounds.length - 1])}`, value: bounds[bounds.length - 1] });

  return (
    <div
      style={{
        position: 'absolute',
        top: '10px',
        right: '10px',
        display: 'flex',
        flexDirection: 'column',
        background: 'rgba(255, 255, 255, 0.9)',
        padding: '6px 10px',
        borderRadius: '4px',
        boxShadow: '0 0 4px rgba(0,0,0,0.3)',
        zIndex: 999,
        pointerEvents: 'none',
        fontSize: '12px',
        lineHeight: 1.2,
      }}
    >
      {bins.map((bin, idx) => {
        const color = colors[idx] || '#cccccc';
        const { label } = bin;
        return (
          <div
            key={label}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              margin: '2px 0',
              textAlign: 'left',
            }}
          >
            <div
              style={{
                width: '28px',
                height: '12px',
                background: color,
                border: '1px solid #000',
                marginRight: '6px',
              }}
            />
            <span>{label}</span>
          </div>
        );
      })}
    </div>
  );
}

LegendBar.propTypes = {
  metricType: PropTypes.oneOf(['wages', 'emp_count', 'employment']).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Map/LegendBar.js